export default __webpack_public_path__ + "static/media/danskgo-mobile-1.156df3fc.png";